/* eslint-disable no-useless-escape */
import _ from 'lodash';

export const isLinkedinLink = value => /^(https?:\/\/){0,1}(www\.){0,1}linkedin\.com/.test(value);

export const isValidEmail = (email) => {
  if (_.isEmpty(email)) return false;
  const emailExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const regex = new RegExp(emailExpression);
  return Boolean(email.match(regex));
};

export const isValidPhoneNumber = (phoneNumber) => {
  if (_.isEmpty(phoneNumber)) return false;
  const phoneExpression = /^\+\d{7,15}$/g;
  // const phoneExpression = /(\(?\+?[0-9]*\)?)?-?\.?\(?\d{3}[\-\)\.\s]?\d{3}[\-\.\s]?\d{3,4}$/g; // TBD. Simplify this for now
  const regex = new RegExp(phoneExpression);
  return Boolean(phoneNumber.match(regex));
};

export const validateUrl = value => /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);

const MIN_WIDTH = 595; // px
const MIN_HEIGHT = 420; // px
export const validatePhoto = ({ imageWidth, imageHeight }) =>
  imageWidth >= MIN_WIDTH && imageHeight >= MIN_HEIGHT;

export const isValidObjectId = id => /^[a-f\d]{24}$/i.test(id);

export const isValidHubspotDealId = (number) => {
  const validInput = /(^$)|(^[1-9]\d*$)/g;
  return validInput.test(number) && (number <= Number.MAX_SAFE_INTEGER);
};
